import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { HvTabs, HvTab } from '@hitachivantara/uikit-react-core';
import { useAuth, Can } from '@iq/react-components';
import config from '../../../config';

import UsersTab from './components/UserTab/UserTab';
import InvitationsTab from './components/InvitationTab/InvitationTab';
import { requestMemberTypes, requestMembers, requestInvitations } from '../../../bundles/auth';
import { getActiveSite } from '../../../bundles/sites';
import { requestUsers } from '../../../bundles/ad';

const MemberView = ({ wizardType }) => {
  const dispatch = useDispatch();
  const { realm } = useAuth();
  const site = useSelector(getActiveSite);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (site.id) {
      dispatch(requestUsers());
      dispatch(requestMemberTypes());
      if (!config.onPremise) {
        dispatch(requestInvitations(realm));
      }
      dispatch(requestMembers(`site/${site.id}`));
    }
  }, [site.id, realm]);

  const handleChange = (_event, newTabIndex) => setTabIndex(newTabIndex);

  return (
    <div className="site-admin--member-view">
      <HvTabs
        id="tabs-content-change"
        value={tabIndex}
        onChange={handleChange}
      >
        <HvTab
          id="users"
          label="Users"
        />
        {!config.onPremise && (
          <HvTab
            id="invitations"
            label="Invitations"
          />
        )}
      </HvTabs>
      <div className="site-admin--member-view__content">
        {tabIndex === 0 && (
          <UsersTab
            siteId={site.id}
            wizardType={wizardType}
          />
        )}
        {!config.onPremise && tabIndex === 1 && (
          <Can
            permission="invitations/Read"
            scope={site.id ? { org: realm, site: site.id } : { org: realm }}
          >
            <InvitationsTab
              siteId={site.id}
              wizardType={wizardType}
            />
          </Can>
        )}
      </div>
    </div>
  );
};

export default MemberView;
